export default __webpack_public_path__ + "static/media/google-icon.536c9959.svg";